import React, { useState, useRef, useEffect } from 'react';
import './Contact.css'; // Import your CSS file for styling
import cat from '../../assets/gif/cat.gif'; // Example GIF import
import SignatureButton from '../SignatureButton/SignatureButton';

const services = [
  { id: 'site-from-scratch', label: 'Site from scratch' },
  { id: 'ux-ui-design', label: 'UX/UI design' },
  { id: 'branding', label: 'Branding' },
  { id: 'development', label: 'Development' },
  { id: 'maintenance', label: 'Maintenance' },
  { id: 'e-commerce', label: 'E-commerce' },
  { id: 'general-inquiry', label: 'General inquiry' },
];

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    services: [],
    message: ''
  });

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleServiceToggle = (service) => {
    const updated = formData.services.includes(service)
      ? formData.services.filter((s) => s !== service)
      : [...formData.services, service];
    setFormData({ ...formData, services: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://kevinfuller.me/send-email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setIsFormSubmitted(true);
      } else {
        alert('Failed to send email');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while sending the email');
    }
  };

  const isServiceSelected = (service) => formData.services.includes(service);

  const textareaRef = useRef(null);

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  useEffect(() => {
    adjustTextareaHeight();
    // Remeasure after the details panel finishes opening
    const t = window.setTimeout(adjustTextareaHeight, 80);
    return () => window.clearTimeout(t);
  }, [formData.message, formData.services.length]);

  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const contactSection = document.getElementById('contact');
      if (!contactSection) return;

      const contactPosition = contactSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (contactPosition < windowHeight * 0.75) {
        setIsInView(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const detailsUnlocked = formData.services.length > 0;

  return (
    <section id="contact">
      <div className="contact-inner">
        <aside className="contact-aside">
          <span className={`contact-eyebrow fade-in ${isInView ? 'active' : ''}`}>
            Let&apos;s work together
          </span>
          <h2 className={`fade-in ${isInView ? 'active' : ''}`}>
            Have an idea?<br />
            <span className="contact-italic">I&apos;d love to help.</span>
          </h2>
          <p className={`contact-lead fade-in ${isInView ? 'active' : ''}`}>
            Tell me a little about what you&apos;re building. I&apos;ll follow up with honest
            thoughts, clear next steps, and how we can bring it to life together.
          </p>
          <div className={`contact-availability fade-in ${isInView ? 'active' : ''}`}>
            <span className="status-dot" aria-hidden="true"></span>
            Currently available for new projects
          </div>
        </aside>

        <div className={`contact-panel fade-in ${isInView ? 'active' : ''}`}>
          {isFormSubmitted ? (
            <div className="thank-you-message">
              <h3>
                Thanks for<br />
                <span className="contact-italic">reaching out!</span>
              </h3>
              <p>I&apos;ll get back to you soon.</p>
              <img src={cat} alt="cat typing" />
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-section">
                <label>I&apos;m interested in...</label>
                <div className="button-container">
                  {services.map((service) => (
                    <button
                      key={service.id}
                      type="button"
                      className={isServiceSelected(service.id) ? 'selected' : ''}
                      onClick={() => handleServiceToggle(service.id)}
                    >
                      {service.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className={`form-section animated-section ${detailsUnlocked ? 'active' : ''}`}>
                <div className="field">
                  <label htmlFor="name">Your name</label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Jane Doe"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="field">
                  <label htmlFor="email">Your email</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="jane@company.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="field">
                  <label htmlFor="message">Tell me about your project</label>
                  <textarea
                    name="message"
                    id="message"
                    className="contact-message"
                    placeholder="A few sentences on your goals, timeline, and anything you already have in mind..."
                    value={formData.message}
                    onChange={handleChange}
                    ref={textareaRef}
                    rows={4}
                    required
                  />
                </div>

                <SignatureButton type="submit" className="contact-submit">
                  Send request
                </SignatureButton>
              </div>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
